import axios from "axios";
import { BrandRFMSetting } from "../models/brandRFMSetting";
import { BrandRFMProfile } from "../models/brandRFMProfile";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export const brandRFMProfileApi = {
  getBrandRFMProfile: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetBrandRFMProfile`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  listBrandRFMProfile: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/ListBrandRFMProfile`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  getBrandRFMProfileById: async (
    token: string,
    brandId: string,
    profileId: number
  ) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetBrandRFMProfileById`,
      { brandId: brandId, Id: profileId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  createBrandRFMProfile: async (token: string, profile: BrandRFMProfile) => {
    return axios.post(`${API_BASE_URL}/v1/RFM/CreateBrandRFMProfile`, profile, {
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  updateBrandRFMProfile: async (token: string, profile: BrandRFMProfile) => {
    return axios.post(`${API_BASE_URL}/v1/RFM/UpdateBrandRFMProfile`, profile, {
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  setDefaultBrandRFMProfile: async (
    token: string,
    profile: BrandRFMProfile
  ) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/SetDefaultBrandRFMProfile`,
      { brandId: profile.BrandId, Id: profile.Id },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  activateBrandRFMProfile: async (token: string, profileId: number) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/ActivateBrandRFMProfile`,
      { Id: profileId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  deleteBrandRFMProfile: async (token: string, profileId: number) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/DeleteBrandRFMProfile`,
      { Id: profileId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
